import type { ReactStoryblokComponent } from "types/storyblok";
import { Testimonials } from "modules/sections/Testimonials";
import type { TestimonialsProps } from "modules/sections/Testimonials";

const TestimonialsSectionAdapter = ({
  blok: { cards, title, id, display },
}: ReactStoryblokComponent<TestimonialsProps>) => (
  <Testimonials cards={cards} title={title} id={id} display={display} />
);
export default TestimonialsSectionAdapter;
